import { render, staticRenderFns } from "./CzUndoBar.vue?vue&type=template&id=5a6a95ec&scoped=true&"
import script from "./CzUndoBar.vue?vue&type=script&lang=ts&"
export * from "./CzUndoBar.vue?vue&type=script&lang=ts&"
import style0 from "./CzUndoBar.vue?vue&type=style&index=0&id=5a6a95ec&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a6a95ec",
  null
  
)

export default component.exports